import React, { useEffect, useRef } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link, useNavigate } from "react-router-dom";
import { verifyAuth } from "../services/authservices";
import authService from "../services/authservices";

function Privacypolicy() {
  const navigate = useNavigate();
  const [offset, setOffset] = useState(0);
  const advanceSectionRef = useRef(null);
  const [userAuth, setAuth, userAuthref] = useState(false);

  const [siteDatacomes, setSiteData] = useState("");

  const [loginCheck, setloginCheck] = useState(false);


  useEffect(() => {
    getSitedata();

    let userToken = localStorage.getItem("token");
    if (userToken) {
      setloginCheck(true);
    } else {
      setloginCheck(false);
    }
  }, [0]);

  const getSitedata = async () => {
    try {
      const data = await authService.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    const handleScroll = () => {
      if (advanceSectionRef.current) {
        const sectionTop = advanceSectionRef.current.offsetTop;
        const sectionHeight = advanceSectionRef.current.offsetHeight;
        const pageOffset = window.pageYOffset;

        if (
          pageOffset >= sectionTop &&
          pageOffset <= sectionTop + sectionHeight
        ) {
          setOffset(pageOffset - sectionTop);
        } else {
          setOffset(0);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    checkuserAuth();
  }, [0]);

  const checkuserAuth = async () => {
    const token = localStorage.getItem("token");
    if (token != null) {
      try {
        const data = await verifyAuth(token);
        if (data && data.status) {
          setAuth(true);
        } else {
          setAuth(false);
        }
      } catch (error) {
        console.error("Error auth user details:", error);
        setAuth(false);
      }
    } else {
      setAuth(false);
    }
  };

  const nav_page = () => {
    if (!userAuthref.current) {
      navigate("/register");
    } else {
      navigate("/home");
    }
  };

  return (
    <>
      <main className="wyscale_landing_main">
        <section>
          <Header />
        </section>
        <section className="dashboard_content_section">
          <div className="container">
            <div className="smart_dashboard_content" id="privacy-condition">
              <h2>Privacy Policy</h2>
              <div className="row">
                <div className="col-lg-12">
                  <div className="dash_board_profile_content">
                    <div className="contentpage">
                      <p>
                      Binarge ("Binarge," "we," "our," or "us") values your privacy and is committed to transparency regarding how we handle data. This Privacy Policy applies to information we collect when you use our website and other online services that link to this Privacy Policy (collectively, the "Services").
                      </p>

                      <h3>Important Clarifications:</h3>
                      <h4>
                      Binarge provides automated trading software. We do not offer financial products, manage user funds, or provide investment services.
We do not collect personal financial information. Users remain in full control of their funds at all times.
All interactions with our platform are non-custodial, meaning that users execute trades directly from their wallets
                      </h4>

                      <h3>Information We Collect</h3>

                      <p>
                      Information You Provide to Us We collect only minimal information directly from you, specifically:
                      </p>

                      <p>
                      Wallet Information:
                      Public blockchain wallet addresses used to interact with Binarge.
                      Transaction and balance information (blockchain data) that is accessible when using the Interface.
                      We do not collect your name, email address, phone number, or any other personally identifiable information.
                      Blockchain Information:
                      Details of the blockchain networks you interact with while using our software.
                      Any transaction data you make public on the blockchain is beyond our control, as blockchain transactions are inherently transparent.
                      Transaction Information (Anonymized Data Only):
                      We collect only anonymized transaction data, including trade amounts and token details, for service optimization.
                      This data is used to improve performance, provide analytics, and ensure the smooth operation of the software.
                      Note: We do not track or store any private keys, seed phrases, or sensitive financial information.
                      </p>

                      <h3>Information We Collect Automatically</h3>

                      <p>
                      Trading and Exchange Information:
                      Data related to trading activity, including the automated strategies executed via the software.
                      We do not access or control user funds; all transactions are conducted through the user’s own wallet.
                      Device and Usage Data:
                      General technical data such as device type, operating system, and browser type.
                      Interaction data with the Interface (e.g., page views, clicks) to improve the user experience.
                      Strategy Information:
                      Your trading strategies remain your intellectual property.
                      Binarge does not store or claim ownership over any strategies you create. You are responsible for securing and managing your strategies.

                      </p>

                      <h3>How We Use Your Information</h3>

                      <p>
                      We use collected data strictly for:

                      Providing and improving our Services (e.g., optimizing automated trading execution).
                      Security and compliance purposes (e.g., ensuring fair usage and preventing unauthorized access).
                      Technical improvements and troubleshooting.
                      We do not use your data for:

                      Financial advisory services.
                      Portfolio management.
                      Selling or sharing with third parties for marketing purposes.

                      </p>
                      <h3>Sharing and Disclosure</h3>
                      <p>
                      We Do Not Share Personal or Financial Information
                      Your wallet and transaction data will not be shared with third parties, except for anonymized data used for analytics.
                      We may use third-party service providers (e.g., Google Analytics, Cloudflare) to analyze user behavior, but these services do not have access to private financial data.
                      External Service Providers
                      Some services, such as blockchain analytics tools, may collect publicly available blockchain data.
                      Binarge has no control over third-party services, and you should review their respective privacy policies.

                      </p>
                      <h3>Security and User Responsibility</h3>
                      <p>
                      We take security seriously and implement best practices to protect user data. However:

                      Your blockchain transactions are public by design. Binarge cannot alter or delete blockchain records.
                      You are responsible for securing your wallet and private keys.
                      We are not liable for losses incurred due to user mismanagement of funds, leaked strategies, or market volatility.

                      </p>
                      <h3>Social Network Plugins</h3>
                      <p>
                      Our website may incorporate social network plugins for easy sharing. These plugins do not collect cookies unless you voluntarily interact with them. The data collection policies of social networks are governed by their respective privacy policies.
                      </p>
                      <h3>Use of Services - Your Responsibility By using our Services:</h3>
                      <p>
                      You acknowledge and accept all risks associated with blockchain-based trading. You understand that Binarge provides software only and does not manage funds or guarantee profits. Binarge, its owners, and affiliates will not be liable for any trading losses or financial damages incurred through the use of our software.
                      </p>
                      <h3>Your Consent </h3>
                      <p>
                      By using our website and services, you agree to the terms outlined in this Privacy Policy.
                      </p>
                      <p>
                      If you have any questions or need further clarification, contact us at wecare(@)binarge.com
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="footer_section">
          <div className="container">
            <section className="row mx-0 bn-footer-row g-4 g-lg-1">
              <div className="col-lg-6 col-sm-6 col-12">
                <div>
                  <img
                    src={require("./img/footer-logo.webp")}
                    alt=""
                    className="bn-footer-logo"
                  />
                  <p className="bn-footer-logo-content">
                    AI-powered crypto trading bot with blockchain security for
                    seamless and automated trading.
                  </p>
                </div>
              </div>
              <div className="col-lg-2 col-sm-4 col-6">
                <h6 className="bn-footer-link-title">Explore</h6>
                <ul className="bn-footer-lists">
                  {/* <li>
                    <Link to="/" className="bn-footer-links">
                      Newbies
                    </Link>
                  </li>
                  <li>
                    <Link to="/" className="bn-footer-links">
                      Knowledge Base
                    </Link>
                  </li>
                  <li>
                    <Link to="/" className="bn-footer-links">
                      Strategies
                    </Link>
                  </li> */}
                  <li>
                    <Link to="/termscondition" className="bn-footer-links">
                      Terms and Service
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacypolicy" className="bn-footer-links">
                      Privacy Policy
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col-lg-2 col-sm-6 col-6">
                <h6 className="bn-footer-link-title">Support</h6>
                <ul className="bn-footer-lists">
                  {/* <li>
                               <Link to="/" className="bn-footer-links">
                                 Terms & Conditions
                               </Link>
                             </li>
                             <li>
                               <Link to="/" className="bn-footer-links">
                                 Privacy Policy
                               </Link>
                             </li> */}
                  <li>
                    <Link to={loginCheck ? "/support" : "/login"} className="bn-footer-links">
                      Help Center
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-2 col-sm-6 col-6">
                <h6 className="bn-footer-link-title">Social</h6>
                <ul className="bn-footer-icon-wrap">
                <li>
                        <a target="_blank" href={siteDatacomes.instagram}>
                            <img src={require("./img/instagram.webp")} alt="" />
                          </a>
                        </li>
                        <li>
                        <a target="_blank"  href={siteDatacomes.twitter}>
                            <img src={require("./img/x.webp")} alt="" />
                          </a>
                        </li>
                        <li>
                        <a target="_blank" href={siteDatacomes.telegram}>
                        <img src={require("./img/telegram.webp")} alt="" />
                          </a>
                        </li>
                </ul>
              </div>
            </section>
          </div>
        </section>
        <div className="footer_last">
          <span className="footer_copyrights">
            ©2025 Binarge. All Rights Reserved.
          </span>
        </div>
      </main>
    </>
  );
}

export default Privacypolicy;
